<p>update-multi-auth-success works!</p>
